<template>
  <div class="apc-wrap">
    <modal name="assignPromoCode" class="apc-modal" @before-close="onClose" @before-open="reset" height="auto" :scrollable="true" :adaptive="true" width="90%" :maxWidth="620">
      <div class="apc-dialog">
        <div class="apc-dialog-header">
          <div class="apc-dialog-header-left">
            <span class="apc-dialog-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
                <line x1="7" y1="7" x2="7.01" y2="7"/>
              </svg>
            </span>
            <div>
              <h2 class="apc-dialog-title">Assign Promo Code</h2>
              <p class="apc-dialog-sub">Search for an available promo code and attach it to this runner</p>
            </div>
          </div>
          <button class="apc-close-btn" type="button" title="Close" @click="$modal.hide('assignPromoCode')">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div class="apc-dialog-body">
        <div class="apc-search-container">
           <label class="apc-label">Search Promo Code</label>
           <input type="text" v-model="searchQuery" @input="onSearch" placeholder="Type to search..." class="apc-input">
           
           <div v-if="isLoading" class="apc-loading">Searching...</div>

           <ul v-if="results.length > 0" class="promo-results">
              <li v-for="code in results" :key="code.id" @click="selectCode(code)" :class="{ 'selected': selectedCode && selectedCode.id === code.id }">
                  {{ code.code }} 
                  <span v-if="code.description" class="apc-result-desc">{{ code.description }}</span>
              </li>
           </ul>
           <div v-else-if="!isLoading && searchQuery.length > 0 && results.length === 0" class="apc-empty">
              No promo codes found.
           </div>
        </div>

        <div v-if="selectedCode" class="apc-selected">
            <strong>Selected:</strong> {{ selectedCode.code }}
        </div>

        <p v-if="error" class="apc-error">{{ errorMessage }}</p>
        </div>
        <div class="apc-dialog-footer">
            <button class="apc-cancel-btn" type="button" @click="$modal.hide('assignPromoCode')">Cancel</button>
            <button class="apc-save-btn" type="button" :disabled="!selectedCode" @click="assign">Assign</button>
        </div>
      </div>
    </modal>  
  </div>
</template>

<script>
  import PromoCodeService from '../../../services/promoCode'
  import _ from 'lodash' // For debounce

  export default {
    name: 'assign-promo-code',
    data: () => ({
        searchQuery: '',
        results: [],
        selectedCode: null,
        isLoading: false,
        error: false,
        errorMessage: ''
    }),
    props: {
        runnerId: ''
    },
    methods: {
        onClose() {
             this.$emit('closed', true)
        },
        onSearch: _.debounce(function() {
            if (this.searchQuery.length < 2) {
                this.results = []
                return
            }
            this.isLoading = true
            this.error = false
            PromoCodeService.getAllPromoCodes(this.searchQuery, 0, 20).then(response => {
                this.results = response.data.content || response.data // Handle Page object or List
                this.isLoading = false
            }).catch(err => {
                console.error(err)
                this.isLoading = false
            })
        }, 300),
        selectCode(code) {
            this.selectedCode = code
        },
        assign() {
            if (!this.selectedCode) return
            
            this.isLoading = true
            this.error = false
            
            PromoCodeService.claimCode(this.selectedCode.code, this.runnerId).then(response => {
                this.isLoading = false
                this.$emit('saved', response.data)
                this.$modal.hide('assignPromoCode')
                this.$dialog.alert("Promo Code assigned successfully!")
            }).catch(error => {
                this.isLoading = false
                this.error = true
                console.error("Assignment failed", error)
                let msg = "Failed to assign promo code."
                if (error.body && error.body.message) {
                    msg = error.body.message
                }
                this.errorMessage = msg
            })
        },
        reset() {
            this.searchQuery = ''
            this.results = []
            this.selectedCode = null
            this.error = false
            this.errorMessage = ''
        }
    },
    watch: {
       // Watch for modal open to reset?
       // The parent usually calls a method or v-if handles it.
       // AddRaceData uses openEditModal method called by parent.
    }
  }
</script>

<style scoped>
.apc-dialog {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}
.apc-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.2rem 1.75rem;
  border-bottom: 1px solid #f0f0f5;
}
.apc-dialog-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.apc-dialog-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f0effe;
  color: #5b4fcf;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
}
.apc-dialog-title {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
}
.apc-dialog-sub {
  font-size: 12px;
  color: #8a8a9a;
  margin: 4px 0 0;
}
.apc-close-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #e8e8ed;
  background: #fff;
  color: #8a8a9a;
  cursor: pointer;
}
.apc-close-btn:hover {
  color: #c0392b;
  border-color: #ffd6d6;
}
.apc-dialog-body {
  padding: 1.5rem 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}
.apc-label {
  display: block;
  margin-bottom: 0.45rem;
  font-size: 12px;
  font-weight: 600;
  color: #1a1a2e;
}
.apc-input {
  width: 100%;
  height: 40px;
  border: 1px solid #e8e8ed;
  border-radius: 8px;
  background: #fafafa;
  padding: 0 0.75rem;
  color: #1a1a2e;
  font-size: 14px;
}
.apc-input:focus {
  outline: none;
  border-color: #5b4fcf;
  box-shadow: 0 0 0 3px rgba(91, 79, 207, 0.12);
}
.apc-loading,
.apc-empty {
  margin-top: 0.7rem;
  color: #8a8a9a;
  font-size: 12px;
}
.promo-results {
  list-style: none;
  padding: 0;
  margin: 0.7rem 0 0;
  border: 1px solid #e8e8ed;
  border-radius: 9px;
  max-height: 220px;
  overflow-y: auto;
}
.promo-results li {
  padding: 0.75rem;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f5;
  color: #1a1a2e;
  font-size: 13px;
}
.promo-results li:hover {
  background: #fafafa;
}
.promo-results li.selected {
  background: #f0effe;
  color: #413b94;
  font-weight: 700;
}
.apc-result-desc {
  color: #8a8a9a;
  font-size: 12px;
  margin-left: 10px;
}
.apc-selected {
  padding: 0.75rem;
  background: #fafafa;
  border: 1px solid #e8e8ed;
  border-radius: 9px;
  color: #1a1a2e;
  font-size: 13px;
}
.apc-error {
  font-size: 12px;
  color: #c0392b;
  margin: 0;
}
.apc-dialog-footer {
  border-top: 1px solid #f0f0f5;
  padding: 1rem 1.75rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}
.apc-cancel-btn,
.apc-save-btn {
  height: 36px;
  border-radius: 8px;
  padding: 0 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.apc-cancel-btn {
  border: 1px solid #e0e0ea;
  background: #fff;
  color: #5b4fcf;
}
.apc-save-btn {
  border: none;
  background: #5b4fcf;
  color: #fff;
}
.apc-save-btn:hover {
  background: #4338ca;
}
.apc-save-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// AssignPromoCode.vue?7f88150a